"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _reactTable = require("react-table");

var _core = require("@dnd-kit/core");

var _modifiers = require("@dnd-kit/modifiers");

var _clsx = _interopRequireDefault(require("clsx"));

var _hooks = require("../../hooks");

var _Pagination = _interopRequireDefault(require("../Pagination/Pagination"));

var _CellWithAvatar = _interopRequireDefault(require("./CellWithAvatar/CellWithAvatar"));

var _CellWithButton = _interopRequireDefault(require("./CellWithButton/CellWithButton"));

var _CellWithCheckbox = _interopRequireDefault(require("./CellWithCheckbox/CellWithCheckbox"));

var _Header = _interopRequireDefault(require("./Header/Header"));

var _EmptyTable = _interopRequireDefault(require("./EmptyTable/EmptyTable"));

var _AllSelection = _interopRequireDefault(require("./AllSelection/AllSelection"));

var _TableControls = _interopRequireDefault(require("./TableControls/TableControls"));

var _TableContent = _interopRequireDefault(require("./TableContent/TableContent"));

var _TableBody = _interopRequireDefault(require("./TableBody/TableBody"));

var _TableHeaderRow = require("./TableHeaderRow/TableHeaderRow");

var _StatusHint = _interopRequireDefault(require("./StatusHint/StatusHint"));

var _RowSelection = _interopRequireDefault(require("./RowSelection/RowSelection"));

var _RowControls = _interopRequireDefault(require("./RowControls/RowControls"));

var _StaticTableRow = _interopRequireDefault(require("./TableRow/StaticTableRow"));

var _Table = require("./Table.styles");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getTableInfo = function getTableInfo(showPagination, config, data) {
  // Default config for pageSize and current page
  var info = {
    defaultPageSize: 5,
    defaultCurrent: 1
  };

  if (showPagination) {
    // Merge with config data
    info = _objectSpread(_objectSpread({}, info), config);
  } else {
    // If don't show pagination, show all data in one page
    // the min size should be 1
    info.defaultPageSize = data.length || 1;
  }

  return info;
};

var Table = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, inputRef) {
  var _headerGroups$, _headerGroups$$header;

  var columns = _ref.columns,
      data = _ref.data,
      setData = _ref.setData,
      children = _ref.children,
      className = _ref.className,
      headerCellCls = _ref.headerCellCls,
      separate = _ref.separate,
      showPagination = _ref.showPagination,
      pagination = _ref.pagination,
      draggable = _ref.draggable,
      disableReorder = _ref.disableReorder,
      searchPlaceholder = _ref.searchPlaceholder,
      controls = _ref.controls,
      hasSearch = _ref.hasSearch,
      header = _ref.header,
      updateData = _ref.updateData,
      deleteData = _ref.deleteData,
      onEdit = _ref.onEdit,
      emptyHint = _ref.emptyHint,
      emptyHintVisible = _ref.emptyHintVisible,
      hasRemoveSorting = _ref.hasRemoveSorting,
      onSelectedRowsChange = _ref.onSelectedRowsChange,
      onSelectedRowIdsChange = _ref.onSelectedRowIdsChange,
      onSelectedModeChange = _ref.onSelectedModeChange,
      dataType = _ref.dataType,
      loading = _ref.loading,
      hasError = _ref.hasError,
      onRefresh = _ref.onRefresh,
      emptyContent = _ref.emptyContent,
      disabled = _ref.disabled,
      disabledHint = _ref.disabledHint,
      controlsStyles = _ref.controlsStyles,
      onTableStateChange = _ref.onTableStateChange,
      sorting = _ref.sorting,
      errorTitle = _ref.errorTitle,
      errorSubtitle = _ref.errorSubtitle,
      errorImg = _ref.errorImg,
      noSearchResultTitle = _ref.noSearchResultTitle,
      noSearchResultSubtitle = _ref.noSearchResultSubtitle,
      noSearchResultImg = _ref.noSearchResultImg,
      useCustomHook = _ref.useCustomHook,
      defaultSelectedRowIds = _ref.defaultSelectedRowIds,
      defaultGlobalFilter = _ref.defaultGlobalFilter,
      tableActionsRef = _ref.tableActionsRef,
      tableWrapperStyles = _ref.tableWrapperStyles,
      showHeader = _ref.showHeader,
      onReorder = _ref.onReorder,
      scroll = _ref.scroll,
      maxSkeletonSize = _ref.maxSkeletonSize,
      disableSortRemove = _ref.disableSortRemove;
  var sortDisableRef = (0, _react.useRef)(false);

  var _getTableInfo = getTableInfo(showPagination, pagination, data),
      defaultPageSize = _getTableInfo.defaultPageSize,
      defaultCurrent = _getTableInfo.defaultCurrent,
      pageTotal = _getTableInfo.pageTotal,
      server = _getTableInfo.server;

  var _useTableScroll = (0, _hooks.useTableScroll)(_objectSpread(_objectSpread({}, scroll), {}, {
    inputRef: inputRef,
    loading: loading
  })),
      scrollRef = _useTableScroll.scrollRef,
      executeResetScroll = _useTableScroll.executeResetScroll;

  var stateReducer = (0, _react.useCallback)(function (newState, action, prevState) {
    // Update pageSize for adding new rows, otherwise the length of page data from useTable hook will not change
    // no need to update pageSize for table that shows pagination
    var updatedNewState = onTableStateChange(newState, action, prevState) || newState;

    var _ref2 = action || {},
        type = _ref2.type;

    if (type === 'gotoPage') {
      executeResetScroll();
    }

    if (showPagination) {
      return updatedNewState;
    }

    return _objectSpread(_objectSpread({}, updatedNewState), {}, {
      pageSize: defaultPageSize
    });
  }, [defaultPageSize, showPagination, onTableStateChange, executeResetScroll]);
  var getRowId = (0, _react.useCallback)(function (row) {
    return row.id;
  }, []);
  var columnsWithoutDefaultWidth = (0, _react.useMemo)(function () {
    return columns.map(function (column) {
      return _objectSpread(_objectSpread({}, column), {}, {
        // If not set, react-table will give 150px
        width: column.width || 'auto'
      });
    });
  }, [columns]); // Use the state and functions returned from useTable to build your UI

  var _useTable = (0, _reactTable.useTable)({
    // Must be memoized,
    // and the useMemo dependencies should be empty to avoid rerendering all cells when the data is changed
    columns: columnsWithoutDefaultWidth,
    data: data,
    // They aren't part of the API, but
    // anything we put into these options will
    // automatically be available on the instance.
    // That way we can call these functions from our
    // cell renderer to remove dependencies for columns
    updateData: updateData,
    deleteData: deleteData,
    onEdit: onEdit,
    disabled: disabled,
    disabledHint: disabledHint,
    sortDisableRef: sortDisableRef,
    initialState: {
      pageIndex: defaultCurrent - 1,
      pageSize: defaultPageSize,
      sortBy: (sorting === null || sorting === void 0 ? void 0 : sorting.defaultSortBy) || [],
      selectedRowIds: defaultSelectedRowIds,
      globalFilter: defaultGlobalFilter,
      // Set hidden columns: array of column ids
      hiddenColumns: columns.filter(function (column) {
        return column === null || column === void 0 ? void 0 : column.hidden;
      }).map(function (column) {
        return column.id || column.accessor;
      })
    },
    stateReducer: stateReducer,
    // Don't reset these when data is changed
    autoResetSortBy: false,
    autoResetGlobalFilter: false,
    autoResetFilters: false,
    autoResetPage: !showPagination,
    // For server side pagination
    manualPagination: !!server,
    manualSortBy: !!server,
    manualGlobalFilter: !!server,
    // Required when server pagination is enabled
    // default to null will cause pagination not work correctly
    // default to -1 if don't want to present the number of pages available
    pageCount: server ? pageTotal : -1,
    // Use this function to change how React Table detects unique rows
    // and also how it constructs each row's underlying id property.
    // default is index, which will not work correctly with selected rows
    getRowId: getRowId,
    autoResetSelectedRows: false,
    disableSortRemove: disableSortRemove
  }, // For filter rows
  _reactTable.useGlobalFilter, // For filter rows in one column
  _reactTable.useFilters, // For sorting
  _reactTable.useSortBy, // For pagination
  _reactTable.usePagination, // For row selection
  _reactTable.useRowSelect, // Get a collection of plugin points
  // Function(hooks)
  useCustomHook),
      getTableProps = _useTable.getTableProps,
      getTableBodyProps = _useTable.getTableBodyProps,
      headerGroups = _useTable.headerGroups,
      page = _useTable.page,
      prepareRow = _useTable.prepareRow,
      gotoPage = _useTable.gotoPage,
      setPageSize = _useTable.setPageSize,
      state = _useTable.state,
      setGlobalFilter = _useTable.setGlobalFilter,
      setFilter = _useTable.setFilter,
      rows = _useTable.rows,
      getToggleAllPageRowsSelectedProps = _useTable.getToggleAllPageRowsSelectedProps,
      selectedFlatRows = _useTable.selectedFlatRows,
      tableToggleAllRowsSelected = _useTable.toggleAllRowsSelected,
      setSortBy = _useTable.setSortBy;

  var _useState = (0, _react.useState)('ids'),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      selectionMode = _useState2[0],
      setSelectionMode = _useState2[1];

  var isSorting = state.sortBy.length > 0;
  var globalFilter = state.globalFilter;
  var hasGlobalFilter = !!globalFilter;
  var noFound = server ? hasGlobalFilter && !data.length : !!data.length && !page.length; // Keep parent selectedRowIds in sync with local selectedRowIds
  // No need to update on mount since we are passing initial state

  (0, _reactTable.useMountedLayoutEffect)(function () {
    if (loading) return;
    onSelectedRowIdsChange(state.selectedRowIds);
  }, [loading, onSelectedRowIdsChange, state.selectedRowIds]); // Detect single selection changes and change the selectionMode back to ids

  (0, _reactTable.useMountedLayoutEffect)(function () {
    if (loading) return;
    var selectedLength = Object.keys(state.selectedRowIds).length;
    var currentPageRowLength = rows.length; // react-table doenst have a callback for when a single checkbox is clicked
    // This means that we have to look at the current state to figure out of the
    // use has clicked a checkbox which would then indicate thate we've exited
    // the "all" selection mode

    if (selectionMode === 'all' && selectedLength < currentPageRowLength) {
      setSelectionMode('ids');
    }
  }, [loading, state.selectedRowIds, setSelectionMode, selectionMode]);
  (0, _reactTable.useMountedLayoutEffect)(function () {
    if (loading) return;
    onSelectedModeChange(selectionMode);
  }, [loading, selectionMode]);
  (0, _reactTable.useMountedLayoutEffect)(function () {
    if (loading) return;
    onSelectedRowsChange(selectedFlatRows.map(function (item) {
      return item.original;
    }));
  }, [loading, onSelectedRowsChange, selectedFlatRows]); // Add Drag&drop feature to reorder the table

  var _useDraggableTable = (0, _hooks.useDraggableTable)({
    draggable: draggable,
    setData: setData,
    disableReorder: disableReorder,
    state: state,
    onReorder: onReorder,
    data: data,
    rows: rows,
    prepareRow: prepareRow
  }),
      dragRowId = _useDraggableTable.dragRowId,
      dragRow = _useDraggableTable.dragRow,
      sensors = _useDraggableTable.sensors,
      handleDragStart = _useDraggableTable.handleDragStart,
      handleDragEnd = _useDraggableTable.handleDragEnd,
      handleDragCancel = _useDraggableTable.handleDragCancel,
      noReorder = _useDraggableTable.noReorder;

  sortDisableRef.current = noReorder;
  var handleChangePage = (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(value) {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // Pass pagination's current page to gotoPage to control table content
              // because goToPage accept pageIndex, so need to minus 1
              gotoPage(value - 1);

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }(), [gotoPage]);
  var handleChangePageSize = (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(value) {
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setPageSize(value);

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref4.apply(this, arguments);
    };
  }(), [setPageSize]);
  var clearSorting = (0, _react.useCallback)(function () {
    setSortBy([]);
  }, [setSortBy]);
  var toggleAllRowsSelected = (0, _react.useCallback)(function (set, mode) {
    setSelectionMode(mode);
    tableToggleAllRowsSelected(set);
  }, [tableToggleAllRowsSelected, setSelectionMode]);

  if (tableActionsRef && tableActionsRef.current) {
    // eslint-disable-next-line no-param-reassign
    tableActionsRef.current.toggleAllRowsSelected = toggleAllRowsSelected;
  } // Can't use tfoot, because it's needed for empty or error content too


  var footer = (0, _jsxRuntime.jsx)("div", {
    css: _Table.styles.footer,
    className: "grui table-footer",
    children: children
  });
  var totalRows = (pagination === null || pagination === void 0 ? void 0 : pagination.total) || rows.length;
  var current = (pagination === null || pagination === void 0 ? void 0 : pagination.current) || state.pageIndex + 1;
  var pageSize = (pagination === null || pagination === void 0 ? void 0 : pagination.pageSize) || state.pageSize;
  var paginated = showPagination && totalRows > pageSize; // using state.selectedRowIds instead of `selectedFlatRows.length` for length calculations
  // because for server side data pagination, props.data contains only items for the current page
  // and selectedFlatRows gets its data from what's currently loaded into react table
  // so we could end up with a case where we have selected rows in previous page but selectedFlatRows not aware of it

  var selectedLength = selectionMode === 'all' ? totalRows : Object.keys(state.selectedRowIds).length;
  var hasPage = !!page.length; // If table has children or hasn't got data but has header, add withFooter styles when show StatusHint

  var withFooter = children || !hasPage && !!header;
  var skeletonSize = pageSize > maxSkeletonSize ? maxSkeletonSize : pageSize;
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(0, _jsxRuntime.jsx)(_TableControls["default"], {
      className: "grui mb-10",
      css: controlsStyles,
      removeSortHidden: !isSorting,
      clearSorting: clearSorting,
      hasSearch: hasSearch,
      controls: controls,
      pageLength: page.length,
      setFilter: setFilter,
      getToggleAllPageRowsSelectedProps: getToggleAllPageRowsSelectedProps,
      hasRemoveSorting: hasRemoveSorting,
      globalFilter: state.globalFilter,
      setGlobalFilter: setGlobalFilter,
      searchPlaceholder: searchPlaceholder,
      disabled: disabled,
      disabledHint: disabledHint
    }), paginated && (0, _jsxRuntime.jsx)(_AllSelection["default"], {
      allLength: totalRows,
      selectedLength: selectedLength,
      type: dataType,
      toggleAllRowsSelected: toggleAllRowsSelected,
      showAllRowsSelectedBanner: getToggleAllPageRowsSelectedProps().checked && selectedLength >= pageSize
    }), header, (0, _jsxRuntime.jsx)("div", {
      css: [_Table.styles.tableWrapper, separate && _Table.styles.separateTableWrapper, header && _Table.styles.withHeader, withFooter && _Table.styles.withFooter, tableWrapperStyles, process.env.NODE_ENV === "production" ? "" : ";label:Table;"],
      style: (scroll === null || scroll === void 0 ? void 0 : scroll.tableHeight) && {
        height: "".concat(scroll === null || scroll === void 0 ? void 0 : scroll.tableHeight, "px")
      },
      children: (0, _jsxRuntime.jsx)("div", {
        children: (0, _jsxRuntime.jsxs)(_core.DndContext, {
          sensors: sensors,
          onDragEnd: handleDragEnd,
          onDragStart: handleDragStart,
          onDragCancel: handleDragCancel,
          collisionDetection: _core.closestCenter,
          modifiers: [_modifiers.restrictToVerticalAxis],
          children: [(0, _jsxRuntime.jsx)(_TableContent["default"], {
            getTableProps: getTableProps,
            getTableBodyProps: getTableBodyProps,
            separate: separate,
            page: page,
            disabled: disabled,
            className: className,
            headerGroups: headerGroups,
            showHeader: showHeader,
            headerCellCls: headerCellCls,
            ref: scrollRef,
            children: (0, _jsxRuntime.jsx)(_TableBody["default"], {
              page: page,
              emptyHintVisible: emptyHintVisible && !loading && !noFound,
              emptyHint: emptyHint,
              prepareRow: prepareRow,
              headersCount: (_headerGroups$ = headerGroups[0]) === null || _headerGroups$ === void 0 ? void 0 : (_headerGroups$$header = _headerGroups$.headers) === null || _headerGroups$$header === void 0 ? void 0 : _headerGroups$$header.length
            })
          }), (0, _jsxRuntime.jsx)(_core.DragOverlay, {
            children: dragRowId && (0, _jsxRuntime.jsx)(_TableContent["default"], {
              getTableProps: getTableProps,
              getTableBodyProps: getTableBodyProps,
              separate: separate,
              page: page,
              disabled: disabled,
              className: className,
              headerGroups: headerGroups,
              showHeader: false,
              headerCellCls: headerCellCls,
              children: (0, _jsxRuntime.jsx)(_StaticTableRow["default"], {
                row: dragRow
              })
            })
          })]
        })
      })
    }), (0, _jsxRuntime.jsx)(_StatusHint["default"], {
      hasError: hasError,
      hasFooter: !!children,
      hasHeader: !!header,
      onRefresh: onRefresh,
      separate: separate,
      loading: loading,
      hasPage: hasPage,
      noFound: noFound,
      emptyContent: emptyContent,
      errorTitle: errorTitle,
      errorSubtitle: errorSubtitle,
      errorImg: errorImg,
      noSearchResultTitle: noSearchResultTitle,
      noSearchResultSubtitle: noSearchResultSubtitle,
      noSearchResultImg: noSearchResultImg,
      pageSize: skeletonSize
    }), children && footer, paginated && (0, _jsxRuntime.jsx)(_Pagination["default"], {
      total: totalRows,
      current: current,
      pageSize: pageSize,
      onChange: handleChangePage,
      showSizeChanger: pagination.showSizeChanger,
      setPageSize: handleChangePageSize,
      className: (0, _clsx["default"])('grui justify-end', pagination.simple && pagination.hideItemsCount ? 'mt-5' : 'mt-10'),
      pageSizeOptions: pagination.pageSizeOptions,
      showLessItems: pagination.showLessItems,
      simple: pagination.simple,
      hideItemsCount: pagination.hideItemsCount,
      disabled: disabled
    })]
  });
});
Table.propTypes = {
  /**
   *  Columns of table, the array should follow this shape: {<br/>
   *  accessor: Display field of the data record and unique key.<br/>
   *  Header: Title of this column.<br/>
   *  width: column width
   * }[]
   * React-table api: https://react-table.tanstack.com/docs/api
   */
  columns: (0, _propTypes.arrayOf)((0, _propTypes.shape)(_TableHeaderRow.columnType)).isRequired,

  /**
   * Data record array to be displayed
   */
  data: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    id: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]).isRequired
  })).isRequired,
  // Callback for set data state: need to be a setState function to provide previous data
  // such as getting new ordered data after drap & drop and resetting order
  setData: _propTypes.func,
  children: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string]),

  /**
   * For styling table element, not the wrapper
   */
  className: _propTypes.string,
  tableWrapperStyles: (0, _propTypes.oneOfType)([(0, _propTypes.shape)({
    name: _propTypes.string,
    styles: _propTypes.string
  }), _propTypes.func]),
  headerCellCls: (0, _propTypes.shape)({
    styles: _propTypes.string
  }),

  /**
   * Table with separete rows;
   */
  separate: _propTypes.bool,

  /**
   * Whether to show pagination
   */
  showPagination: _propTypes.bool,

  /**
   * Pagination config
   */
  pagination: (0, _propTypes.shape)({
    pageSize: _propTypes.number,
    total: _propTypes.number,
    current: _propTypes.number,
    defaultCurrent: _propTypes.number,
    showSizeChanger: _propTypes.bool,
    pageSizeOptions: (0, _propTypes.arrayOf)(_propTypes.number),
    showLessItems: _propTypes.bool,

    /**
     * Enable if server-side pagination is required
     */
    server: _propTypes.bool,

    /**
     * Whether to use simple mode
     */
    simple: _propTypes.bool,

    /**
     * Whether to hide total count info,
     * will move the pagination (navigation part) to the left too if simple is true
     */
    hideItemsCount: _propTypes.bool
  }),

  /**
   * Whether can dragg & drop for rows
   */
  draggable: _propTypes.bool,

  /**
   * Disable drag & drop
   */
  disableReorder: _propTypes.bool,
  searchPlaceholder: _propTypes.string,

  /**
   * Optional controls above the table
   */
  controls: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.func]),

  /**
   * Whether has a search feature
   */
  hasSearch: _propTypes.bool,
  header: _propTypes.node,

  /**
   * Custom function for updating data
   */
  updateData: _propTypes.func,

  /**
   * Custom function for deleting data
   */
  deleteData: _propTypes.func,

  /**
   * Custom function for cell render
   */
  onEdit: _propTypes.func,
  emptyHint: _propTypes.string,
  emptyHintVisible: _propTypes.bool,
  hasRemoveSorting: _propTypes.bool,

  /**
   * Function(selectedRowsArray)
   * selectedRowsArray has the same data structure as the table data
   */
  onSelectedRowsChange: _propTypes.func,

  /**
   * Function(selectedRowIdsObject)
   * selectedRowIdsObject has the same data structure as the defaultSelectedRowIds
   */
  onSelectedRowIdsChange: _propTypes.func,

  /**
   * Function(mode)
   * The selection mode that the table is currently in. ids or all
   */
  onSelectedModeChange: _propTypes.func,
  dataType: _propTypes.string,

  /**
   * Whether it's loading
   */
  loading: _propTypes.bool,

  /**
   * Whether has loading error
   */
  hasError: _propTypes.bool,
  onRefresh: _propTypes.func,
  emptyContent: _propTypes.node,
  disabled: _propTypes.bool,
  disabledHint: _propTypes.string,
  controlsStyles: (0, _propTypes.oneOfType)([(0, _propTypes.shape)({
    styles: _propTypes.string
  }), _propTypes.func]),

  /**
   * Function(state)
   * state:
   * filters
   * hiddenColumns
   * pageIndex
   * pageSize
   * selectedRowIds
   * sortBy
   */
  onTableStateChange: _propTypes.func,
  sorting: (0, _propTypes.shape)({
    changeSort: _propTypes.func,
    defaultSortBy: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
      id: _propTypes.string,
      desc: _propTypes.bool
    }))
  }),

  /**
   * For showing error
   */
  errorTitle: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string]),
  errorSubtitle: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string]),
  errorImg: _propTypes.string,

  /**
   * For showing empty search results
   */
  noSearchResultTitle: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string]),
  noSearchResultSubtitle: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string]),
  noSearchResultImg: _propTypes.string,

  /**
   * Get a collection of plugin points
   * Function(hooks)
   */
  useCustomHook: _propTypes.func,

  /**
   * Object of ids for default selected rows:
   * if a row's ID is set to true in this object, it will have a selected state.
   * {
   *   'id123': true
   * }
   */
  defaultSelectedRowIds: (0, _propTypes.shape)({}),
  defaultGlobalFilter: _propTypes.string,

  /**
   * Ref of custom table actions that can be performed
   */
  tableActionsRef: (0, _propTypes.shape)({
    // eslint-disable-next-line react/forbid-prop-types
    current: _propTypes.any
  }),

  /*
   * Toggle show/hide of table header
   */
  showHeader: _propTypes.bool,
  onReorder: _propTypes.func,
  scroll: (0, _propTypes.shape)({
    /*
     * Reset scroll when pagination changes. Defaults to true
     */
    resetScrollOnPageChange: _propTypes.bool,

    /*
     * Callback when scroll event is detected
     */
    onScroll: _propTypes.func,

    /*
     * Callback when the scroll is reset
     */
    onScrollReset: _propTypes.func,

    /*
     * Optional, target the contaier id of the scroll bar. If this is not provided the first
     * scrollable anchestor will be found and that will have its scroll reset
     */
    scrollContainerId: _propTypes.string,

    /*
     * Optional, the initial scroll position for the datatable
     */
    initialScrollPosition: _propTypes.number,

    /**
     * Set the height for the table (not include pagination and table controls)
     */
    tableHeight: _propTypes.number
  }),
  maxSkeletonSize: _propTypes.number,

  /*
   * If true, the un-sorted state will not be available to columns once they have been sorted.
   */
  disableSortRemove: _propTypes.bool
};
Table.defaultProps = {
  children: undefined,
  className: undefined,
  tableWrapperStyles: undefined,
  headerCellCls: undefined,
  separate: false,
  showPagination: false,
  pagination: undefined,
  draggable: false,
  disableReorder: false,
  searchPlaceholder: '',
  controls: undefined,
  hasSearch: false,
  header: undefined,
  setData: function setData() {},
  updateData: function updateData() {},
  deleteData: function deleteData() {},
  onEdit: function onEdit() {},
  onTableStateChange: function onTableStateChange(newState) {
    return newState;
  },
  emptyHint: 'No items',
  emptyHintVisible: true,
  hasRemoveSorting: false,
  onSelectedRowsChange: function onSelectedRowsChange() {},
  onSelectedRowIdsChange: function onSelectedRowIdsChange() {},
  onSelectedModeChange: function onSelectedModeChange() {},
  dataType: undefined,
  loading: false,
  hasError: false,
  onRefresh: function onRefresh() {},
  emptyContent: undefined,
  disabled: false,
  disabledHint: 'Bulk operation in progress. All functions will be available on completion.',
  controlsStyles: undefined,
  sorting: undefined,
  errorTitle: undefined,
  errorSubtitle: undefined,
  errorImg: undefined,
  noSearchResultTitle: undefined,
  noSearchResultSubtitle: undefined,
  noSearchResultImg: undefined,
  useCustomHook: function useCustomHook() {},
  tableActionsRef: undefined,
  defaultSelectedRowIds: {},
  defaultGlobalFilter: undefined,
  showHeader: true,
  onReorder: null,
  scroll: undefined,
  maxSkeletonSize: 20,
  disableSortRemove: false
};
Table.CellWithAvatar = _CellWithAvatar["default"];
Table.CellWithCheckbox = _CellWithCheckbox["default"];
Table.CellWithButton = _CellWithButton["default"];
Table.Header = _Header["default"];
Table.Empty = _EmptyTable["default"];
Table.RowSelection = _RowSelection["default"];
Table.RowControls = _RowControls["default"];
Table.StatusHint = _StatusHint["default"];
var _default = Table;
exports["default"] = _default;
//# sourceMappingURL=Table.js.map